import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=1daf4c7c"
import script from "./ContactDetails.vue?vue&type=script&lang=js"
export * from "./ContactDetails.vue?vue&type=script&lang=js"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=1daf4c7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports